
export const getAppName = (appName: string | null | undefined) => {
  let thisAppName = null;
  if(appName != undefined){
    thisAppName = appName
  }
  return thisAppName
}

export const getObjectName = (objectName: string | null | undefined) => {
  let thisObjectName = null;
  if(objectName != undefined){
    thisObjectName = objectName
  }
  return thisObjectName
}

export const getRecordUuid = (recordUuid: string | null | undefined) => {
  let thisRecordUuid = null;
  if(recordUuid != undefined){
    thisRecordUuid = recordUuid
  }
  return thisRecordUuid
}
